// LEGACY: Uses @ion/components. New code should use @metarouter-private/mr-mui components instead.
import React from 'react';
import { MrSearch } from '@ion/components';
import propTypes from 'prop-types';

const DEFAULT_PLACEHOLDER = 'Search Email, Action, or Description...';

export default function AuditLogsSearch({ placeholder = DEFAULT_PLACEHOLDER, onChange }) {
  return (
    <>
      <MrSearch testId="auditLogSearch" placeholder={placeholder} onChange={onChange} />
    </>
  );
}

AuditLogsSearch.propTypes = {
  placeholder: propTypes.string,
  onChange: propTypes.func,
};
